export const SEARCH_RESTAURANTS = "SEARCH_RESTAURANTS";
export const SEARCH_ITEMS = "SEARCH_ITEMS";
export const CLEAR_SEARCH = "CLEAR_SEARCH";
export const CLEAR_ITEM_SEARCH = "CLEAR_ITEM_SEARCH";
